import preval from 'preval.macro';

export const getBuildDate = () => {
	return preval`module.exports =  new Date().toLocaleString('ar-AE', {
                                                    year: 'numeric',
                                                    month: '2-digit',
                                                    day: '2-digit',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false, // Set to true if you want to use 12-hour format without AM/PM
                                                })`;
};
export const getBuildDateISO = () => {
	return preval`module.exports =  new Date().toISOString()`;
};
